import { Divider } from "PFComponents/divider";

import css from "../custom_values_list.module.scss";

export const CustomValuesDivider = () => <Divider type="vertical" className={css.divider} />;
